const ROLES = {
  USER: 'USER',
  SUPER_ADMIN: 'SUPER_ADMIN',
  INVESTOR: 'INVESTOR',
  FOUNDER: 'FOUNDER',
}

export default ROLES;
